import HyperLink from "@/components/functionals/HyperLink.vue";
import DatetimeFormatter from "@/components/functionals/DatetimeFormatter.vue";
import ImagePerson from "@/components/functionals/ImagePerson.vue";
import DatetimeCobroFormatter from "@/components/functionals/DatetimeColorCobroFormatter.vue";
import ColorTagsinLineFormatter from "@/components/functionals/ColorTagsinLineFormatter.vue";
import { formatMonto } from "../../../../utils";

export const getColumns = (type) => {
  return columns[type];
};

const invoicesColumns = [
  {
    prop: "DocumentNo",
    label: "No. Factura",
    align: "center",
    minWidth: 110,
    attrs: {
      //   OpenEntryDetails: this.OpenEntryDetails,
      getType: "invoice"
      //   month: 24
    },
    formatter: HyperLink
  },
  {
    prop: "PostingDate",
    label: "Fecha de Factura",
    minWidth: 130,
    formatter: DatetimeFormatter
  },
  {
    prop: "Customer",
    label: "Cliente",
    minWidth: 200
  },

  {
    prop: "Amount",
    label: "Monto",
    sortable: true,
    minWidth: 120,
    formatter: (row) => formatMonto(Number(row.Amount))
  },
  // {
  //   prop: "ClosedDate",
  //   label: "Fecha de Cobro",
  //   width: 170,
  //   formatter: DatetimeCobroFormatter
  // },
  // {
  //   prop: "DocumentType",
  //   label: "Estatus",
  //   sortable: true,
  //   minWidth: 120,
  //   formatter: ColorTagsinLineFormatter
  // },
  {
    prop: "DueDate",
    label: "Fecha de compromiso",
    width: 170,
    formatter: DatetimeFormatter
  },
  {
    prop: "Description",
    label: "Descripcion",
    minWidth: 250
  },
  {
    prop: "Servicio",
    label: "Servicio al cliente",
    minWidth: 240
    // formatter: ImagePerson,
    // attrs: {
    //   imgKey: "ServicioFoto"
    // },
  },
  {
    prop: "Vendedor",
    label: "Vendedor",
    minWidth: 240
    // formatter: ImagePerson,
    // attrs: {
    //   imgKey: "VendedorFoto"
    // },
  },
  {
    prop: "Ejecutivo",
    label: "Servicio de ventas",
    minWidth: 240
    // formatter: ImagePerson,
    // attrs: {
    //   imgKey: "EjecutivoFoto"
    // },
  }
];

const pendingColumns = [
  {
    prop: "DocumentNo",
    label: "No. Factura",
    align: "center",
    minWidth: 110,
    formatter: HyperLink
  },
  {
    prop: "PostingDate",
    label: "Fecha de Factura",
    minWidth: 130,
    formatter: DatetimeFormatter
  },
  {
    prop: "Customer",
    label: "Cliente",
    minWidth: 200
  },
  {
    prop: "Ejecutivo",
    label: "Ejecutivo de Cobros",
    minWidth: 200,
    formatter: ImagePerson,
    sortable: true,
    attrs: {
      imgKey: "accountPhotoExec"
    }
    // formatter: row => formatMonto(Number(row.Amount))
  },
  {
    prop: "Amount",
    label: "Monto",
    sortable: true,
    minWidth: 120,
    formatter: (row) => formatMonto(Number(row.Amount))
  },
  {
    prop: "ClosedDate",
    label: "Fecha de Cobro",
    width: 170,
    formatter: DatetimeCobroFormatter
  },
  {
    prop: "DocumentType",
    label: "Estatus",
    sortable: true,
    minWidth: 120,
    formatter: ColorTagsinLineFormatter
  },
  {
    prop: "DueDate",
    label: "Fecha de compromiso",
    width: 170,
    formatter: DatetimeFormatter
  },
  {
    prop: "Description",
    label: "Descripcion",
    minWidth: 250
  }
];

export const KpiChargesColumns = [
  {
    prop: "DocumentNo",
    label: "No. Factura",
    align: "center",
    minWidth: 110,
    attrs: {
      //   OpenEntryDetails: this.OpenEntryDetails,
      getType: "KpiCharges"
      //   month: 24
    },
    formatter: HyperLink
  },
  {
    prop: "PostingDate",
    label: "Fecha de Factura",
    minWidth: 130,
    formatter: DatetimeFormatter
  },
  {
    prop: "Customer",
    label: "Cliente",
    minWidth: 250
  },
  {
    prop: "Amount",
    label: "Monto",
    sortable: true,
    minWidth: 120
    // formatter: row => formatMonto(Number(row.Amount))
  },
  {
    prop: "ClosedDate",
    label: "Fecha de Cobro",
    width: 170,
    formatter: DatetimeCobroFormatter
  },
  {
    prop: "DocumentType",
    label: "Estatus",
    sortable: true,
    minWidth: 120,
    formatter: ColorTagsinLineFormatter
  },
  {
    prop: "DueDate",
    label: "Fecha de compromiso",
    width: 170,
    formatter: DatetimeFormatter
  }
];
const columns = {
  1: invoicesColumns,
  2: invoicesColumns,
  3: pendingColumns,
  4: KpiChargesColumns
};
